import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import Button from "../common/Button";
import useCurrentConcept from "../hooks/useCurrentConcept";

const StudentLastLessonDashboardWidgetUSA = props => {
    const {...other} = props;
    const [lastConcept, setLastConcept] = useState();
    const [isLoading, setLoading] = useState(true);
    const { loadCurrentConcept } = useCurrentConcept();

    const loadLastConcept = () => {
        setLoading(true);
        axios.get('/web/ui/dashboard/lastConcept')
            .then(response => {
                setLastConcept(response.data);
                setLoading(false);
            });
    }

    const handleClick = conceptId => {
        loadCurrentConcept(conceptId);
    }

    useEffect(() => {
        loadLastConcept();
    }, []);

    return (
        <div className={'ch-dashboard-usa-last-lesson'}>
            <h2>Jump back in</h2>
            <div className={'ch-dashboard-usa-last-lesson-card-wrapper'}>
                <DashboardWidget
                    className={'ch-dashboard-usa-last-lesson-card'}
                    isLoading={isLoading}
                    {...other}>
                    <>
                        {lastConcept &&
                            <>
                                <div className={"ch-dashboard-usa-last-lesson-content"}>
                                    <div>
                                        <p className="ch-dashboard-lesson-link">
                                            {lastConcept.syllabusName} <span className="material-icons">chevron_right</span>
                                            {lastConcept.topicName} <span className="material-icons">chevron_right</span>
                                        </p>
                                        <h3 className={'ch-dashboard-usa-widget-heading'}>{lastConcept.conceptName}</h3>
                                    </div>
                                    <svg className={'ch-icon-sm'} aria-hidden={'true'}
                                         dangerouslySetInnerHTML={{__html: '<use xlink:href="#navLessons-icon"/>'}}
                                         viewBox='0 0 128 128'/>
                                </div>
                                <Button onClick={() => handleClick(lastConcept.conceptId)}>Go to
                                    lesson</Button>
                            </>
                        }
                        {!lastConcept &&
                            <div>
                                <div className="ch-list-item-disabled">You have not viewed any lessons yet. Choose one from the Course Selector at the top left of the screen.</div>
                                </div>
                            }
                        </>
                    </DashboardWidget>
            </div>
        </div>
    )
}

export default StudentLastLessonDashboardWidgetUSA;
